import React from 'react';
import { Modal } from 'react-bootstrap';
import {
  DriveAccessRequestData,
  describeRequestedFile,
} from './useGoogleDrivePicker';
import './google-drive-picker-listener.scss';

/**
 * Consent prompt for a Drive access request. Google's Picker must be opened
 * from a user gesture, so the picker is only launched when "Choose file" is
 * clicked.
 */
const DriveAccessPrompt: React.FC<{
  request: DriveAccessRequestData;
  opening: boolean;
  error: string | null;
  onCancel: () => void;
  onChoose: () => void;
}> = ({ request, opening, error, onCancel, onChoose }) => {
  const fileLabel = describeRequestedFile(request);
  return (
    <Modal
      show
      onHide={onCancel}
      centered
      dialogClassName='drive-picker-consent-modal'
    >
      <Modal.Body>
        <h3 className='drive-picker-consent-modal__title'>
          Grant access to {fileLabel}
        </h3>
        <p className='drive-picker-consent-modal__explanation'>
          Your secretary needs {fileLabel} to continue. Google&apos;s privacy
          rules mean it can only open files that you explicitly grant, so please
          select the file in Google&apos;s file picker to share it.
        </p>
        {error && <p className='drive-picker-consent-modal__error'>{error}</p>}
        <div className='drive-picker-consent-modal__actions'>
          <button
            type='button'
            className='drive-picker-consent-modal__cancel'
            onClick={onCancel}
          >
            Not now
          </button>
          <button
            type='button'
            className='drive-picker-consent-modal__choose'
            disabled={opening}
            onClick={onChoose}
          >
            {opening ? 'Opening…' : 'Choose file'}
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default DriveAccessPrompt;
